import React, { createContext, useContext, useState, useEffect } from "react";
import supabase from "../supabase";

const UserPlanContext = createContext();

export const useUserPlan = () => {
  return useContext(UserPlanContext);
};

export const UserPlanProvider = ({ children }) => {
  const [userPlan, setUserPlan] = useState("Free");
  const [accountType, setAccountType] = useState("Particulier");

  useEffect(() => {
    const fetchUserData = async () => {
      const {
        data: { user },
      } = await supabase.auth.getUser();

      if (user) {
        const { data: profile, error } = await supabase
          .from("profiles")
          .select("plan, pro_until, account_type")
          .eq("id", user.id)
          .single();

      if (profile) {
        setAccountType(profile.account_type);

        // Si c'est un artisan, on utilise directement son plan (Basique, Partenaire, etc.)
        if (profile.account_type === "Artisan") {
          setUserPlan(profile.plan || "Basique");
        } else {
          // Sinon, on applique la logique existante pour les particuliers (Free/Pro)
          const isStillPro =
            profile.plan === "Pro" ||
            (profile.pro_until && new Date(profile.pro_until) > new Date());
          setUserPlan(isStillPro ? "Pro" : "Free");
        }
      } else {
        // Fallback si le profil n'existe pas encore
        setUserPlan("Free");
        setAccountType("Particulier");
      }
    }
    };

    fetchUserData();

    const { subscription } = supabase.auth.onAuthStateChange(
      (_event, session) => {
        if (session?.user) {
          fetchUserData();
        } else {
          setUserPlan("Free");
          setAccountType("Particulier");
        }
      }
    );

    return () => subscription?.unsubscribe();
  }, []);

  return (
    <UserPlanContext.Provider value={{ userPlan, setUserPlan, accountType }}>
      {children}
    </UserPlanContext.Provider>
  );
};
